{
  "AUTOMATION": {
    "HEADER": "Automatizacija",
    "DESCRIPTION": "Automation can replace and streamline existing processes that require manual effort, such as adding labels and assigning conversations to the most suitable agent. This allows the team to focus on their strengths while reducing time spent on routine tasks.",
    "LEARN_MORE": "Learn more about automation",
    "HEADER_BTN_TXT": "Pridėti automatizavimo taisyklę",
    "LOADING": "Gaunamos automatizavimo taisyklės",
    "ADD": {
      "TITLE": "Pridėti automatizavimo taisyklę",
      "SUBMIT": "Sukurti",
      "CANCEL_BUTTON_TEXT": "Atšaukti",
      "FORM": {
        "NAME": {
          "LABEL": "Taisyklės pavadinimas",
          "PLACEHOLDER": "Įvesti taisyklės pavadinimą",
          "ERROR": "Yra reikalingas vardas"
        },
        "DESC": {
          "LABEL": "Aprašymas",
          "PLACEHOLDER": "Įveskite taisyklės aprašymą",
          "ERROR": "Būtinas aprašymas"
        },
        "EVENT": {
          "LABEL": "Įvykis",
          "PLACEHOLDER": "Prašau pasirinkti vieną",
          "ERROR": "Reikalingas įvykis"
        },
        "PHASE": {
          "LABEL": "Etapas"
        },
        "ORDER": {
          "LABEL": "Eilės numeris",
          "ERROR": "Būtina nurodyti eilės numerį"
        },
        "CONDITIONS": {
          "LABEL": "Sąlygos"
        },
        "ACTIONS": {
          "LABEL": "Veiksmai"
        }
      },
      "CONDITION_BUTTON_LABEL": "Pridėti Sąlygas",
      "ACTION_BUTTON_LABEL": "Pridėti Veiksmą",
      "API": {
        "SUCCESS_MESSAGE": "Automatizavimo taisyklė sėkmingai pridėta",
        "ERROR_MESSAGE": "Nepavyko sukurti automatizavimo taisyklės, bandykite dar kartą vėliau"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "PHASE": "Etapas",
        "ORDER": "Eilė",
        "NAME": "Vardas",
        "DESCRIPTION": "Aprašymas",
        "ACTIVE": "Aktyvus",
        "CREATED_ON": "Sukurta",
        "WAIT": "Laukimas"
      },
      "404": "Nerasta jokių automatizavimo taisyklių",
      "TABS": {
        "ALL": "Visos",
        "INSTANT": "Įvykio metu",
        "DELAYED": "Atidėtos"
      },
      "WAITS": "Laukia {duration}"
    },
    "DELETE": {
      "TITLE": "Trinti automatizavimo taisyklę",
      "SUBMIT": "Ištrinti",
      "CANCEL_BUTTON_TEXT": "Atšaukti",
      "CONFIRM": {
        "TITLE": "Patvirtinti Ištrynimą",
        "MESSAGE": "Ar tikrai norite ištrinti ",
        "YES": "Taip, Trinti ",
        "NO": "Ne, Išsaugoti "
      },
      "API": {
        "SUCCESS_MESSAGE": "Automatizavimo taisyklė sėkmingai ištrinta",
        "ERROR_MESSAGE": "Nepavyko ištrinti automatizavimo taisyklės, bandykite dar kartą vėliau"
      }
    },
    "EDIT": {
      "TITLE": "Taisyti automatizavimo taisyklę",
      "SUBMIT": "Atnaujinti",
      "CANCEL_BUTTON_TEXT": "Atšaukti",
      "API": {
        "SUCCESS_MESSAGE": "Automatizavimo taisyklė sėkmingai atnaujinta",
        "ERROR_MESSAGE": "Nepavyko atnaujinti automatizavimo taisyklės, bandykite dar kartą vėliau"
      }
    },
    "CLONE": {
      "TOOLTIP": "Klonuoti",
      "API": {
        "SUCCESS_MESSAGE": "Automatizavimo taisyklė sėkmingai klonuota",
        "ERROR_MESSAGE": "Nepavyko klonuoti automatizavimo taisyklės, bandykite dar kartą vėliau"
      }
    },
    "FORM": {
      "EDIT": "Redaguoti",
      "CREATE": "Sukurti",
      "DELETE": "Ištrinti",
      "CANCEL": "Atšaukti",
      "RESET_MESSAGE": "Pakeitus įvykio tipą bus iš naujo nustatytos sąlygos ir įvykiai, kuriuos pridėjote"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "Norėdami išsaugoti, turite išpildyti bent vieną sąlygą",
      "CONTACT_CUSTOM_ATTR_LABEL": "Kontakto Personalizuoti Požymiai",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "Pokalbio Personalizuoti Požymiai"
    },
    "ACTION": {
      "DELETE_MESSAGE": "Norėdami išsaugoti, turite išpildyti bent vieną veiksmą",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "Rašykite pranešimą čia",
      "TEAM_DROPDOWN_PLACEHOLDER": "Pasirinkite komandas",
      "EMAIL_INPUT_PLACEHOLDER": "Enter email",
      "URL_INPUT_PLACEHOLDER": "Enter URL",
      "SENDER_DROPDOWN_PLACEHOLDER": "Pasirinkite el. pašto aplanką ir siuntėjo adresą",
      "SUBJECT_INPUT_PLACEHOLDER": "El. laiško tema",
      "SMS_INBOX_DROPDOWN_PLACEHOLDER": "Pasirinkite SMS aplanką, iš kurio siųsti",
      "SMS_MESSAGE_INPUT_PLACEHOLDER": "Įveskite SMS tekstą",
      "SMS_COUNTER": "{length}/{limit} simbolių, {segments} SMS (prieš užpildant kintamuosius)"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "Aktyvuoti automatizavimo taisyklę",
      "DEACTIVATION_TITLE": "Išjungti automatizavimo taisyklę",
      "ACTIVATION_DESCRIPTION": "Šis veiksmas suaktyvins automatizavimo taisyklę „{automationName}“. Ar tikrai norite tęsti?",
      "DEACTIVATION_DESCRIPTION": "Šis veiksmas išjungs automatizavimo taisyklę „{automationName}“. Ar tikrai norite tęsti?",
      "ACTIVATION_SUCCESFUL": "Automatizavimo taisyklė sėkmingai aktyvuota",
      "DEACTIVATION_SUCCESFUL": "Automatizavimo taisyklė sėkmingai išjungta",
      "ACTIVATION_ERROR": "Nepavyko aktyvuoti automatizavimo taisyklės, bandykite dar kartą vėliau",
      "DEACTIVATION_ERROR": "Nepavyko išjungti automatizavimo taisyklės, bandykite dar kartą vėliau",
      "CONFIRMATION_LABEL": "Taip",
      "CANCEL_LABEL": "Ne"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "Nepavyko įkelti priedo, bandykite dar kartą",
      "LABEL_IDLE": "Įkelti priedą",
      "LABEL_UPLOADING": "Įkeliama...",
      "LABEL_UPLOADED": "Sėkmingai Įkeltas",
      "LABEL_UPLOAD_FAILED": "Įkelti nepavyko"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_REQUIRED": "Reikalinga vertė",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998",
      "ACTION_PARAMETERS_REQUIRED": "Action parameters are required",
      "ATLEAST_ONE_CONDITION_REQUIRED": "At least one condition is required",
      "ATLEAST_ONE_ACTION_REQUIRED": "At least one action is required"
    },
    "ACTION_NOTICES": {
      "SKIP_AUTO_PRIORITY": "Šis veiksmas veikia tik tada, kai taisyklės etapas nustatytas į „Prieš žymėjimą“.",
      "SKIP_AUTO_LABELING": "Šis veiksmas veikia tik tada, kai taisyklės etapas nustatytas į „Prieš žymėjimą“.",
      "MOVE_CONVERSATION_TO_INBOX": "Į el. pašto gautų laiškų aplanką galima perkelti tik el. pašto ir svetainės pokalbių lango pokalbius, o pokalbių lango – tik jei kontaktas turi el. pašto adresą. Kitu atveju pokalbis lieka vietoje, o vietoj to pridedama privati pastaba.",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Pradeda naują pokalbį su kontaktu pasirinktame el. pašto aplanke, išsiunčia jam pranešimą el. paštu ir pažymi pokalbį kaip išspręstą. Tai vyksta kiekvieną kartą, kai paleidžiama taisyklė. Jei kontaktas neturi el. pašto adreso, niekas neišsiunčiama, o vietoj to pridedama privati pastaba.",
      "SEND_SMS_IN_NEW_CONVERSATION": "Pradeda naują pokalbį su kontaktu pasirinktame SMS aplanke, išsiunčia jam pranešimą SMS žinute ir pažymi pokalbį kaip išspręstą. Tai vyksta kiekvieną kartą, kai paleidžiama taisyklė. Pranešimas yra paprastas tekstas be priedų. Jei kontaktas neturi telefono numerio, niekas neišsiunčiama, o vietoj to pridedama privati pastaba."
    },
    "NOTICES": {
      "AI_PROMPT": "Už kiekvieną atskirą įvertinimą taikomas mokestis.",
      "INCOMING_MESSAGES_COUNT": "Tai nurodo gaunamų pranešimų skaičių pokalbyje.",
      "OUTGOING_MESSAGES_COUNT": "Tai nurodo siunčiamų pranešimų skaičių pokalbyje."
    },
    "PHASE": {
      "BEFORE_LABELING": "Prieš žymėjimą",
      "AFTER_LABELING": "Po žymėjimo"
    },
    "NONE_OPTION": "Nėra",
    "MESSAGE_TYPE_VALUES": {
      "INCOMING": "Incoming Message",
      "OUTGOING": "Outgoing Message",
      "PRIVATE": "Private Note",
      "AI_SUMMARY": "AI Summary"
    },
    "YES_NO_VALUES": {
      "YES": "Taip",
      "NO": "Ne"
    },
    "MESSAGE_SOURCE_TYPE_VALUES": {
      "FACEBOOK_MESSENGER": "Facebook Messenger",
      "INSTAGRAM_DM": "Tiesioginė Instagram žinutė",
      "FACEBOOK_COMMENT": "Facebook komentaras"
    },
    "EVENTS": {
      "CONVERSATION_CREATED": "Pokalbis sukurtas",
      "CONVERSATION_UPDATED": "Pokalbis atnaujintas",
      "MESSAGE_CREATED": "Pranešimas sukurtas",
      "CONVERSATION_OPENED": "Pokalbis atidarytas",
      "CONVERSATION_RESOLVED": "Pokalbis išspręstas",
      "PHONE_CALL_FINISHED": "Skambutis baigtas"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "Priskirti agentui",
      "ASSIGN_TEAM": "Priskirti komandai",
      "ADD_LABEL": "Pridėti etiketę",
      "REMOVE_LABEL": "Pašalinti etiketę",
      "SEND_EMAIL_TO_TEAM": "Siųsti el. laišką komandai",
      "SEND_EMAIL_TRANSCRIPT": "Siųsti pokalbio įrašą el. paštu",
      "SEND_EMAIL_TRANSCRIPT_WITH_DETAILS": "Siųsti išsamų pokalbio įrašą el. paštu",
      "MUTE_CONVERSATION": "Nutildyti pokalbį",
      "SNOOZE_CONVERSATION": "Atidėti pokalbį",
      "RESOLVE_CONVERSATION": "Išspręsti pokalbį",
      "OPEN_CONVERSATION": "Atidaryti pokalbį",
      "SEND_WEBHOOK_EVENT": "Siųsti webhook įvykį",
      "SEND_ATTACHMENT": "Siųsti priedą",
      "SEND_MESSAGE": "Siųsti pranešimą",
      "ADD_NOTE": "Pridėti pastabą",
      "CHANGE_PRIORITY": "Keisti prioritetą",
      "ADD_SLA": "Pridėti SLA",
      "SKIP_AUTO_PRIORITY": "Praleisti automatinį prioritetą",
      "SKIP_AUTO_LABELING": "Praleisti automatinį žymėjimą",
      "AUTO_TRANSLATE": "Versti pranešimą",
      "AUTO_TRANSLATE_CONVERSATION": "Versti pokalbį",
      "MOVE_CONVERSATION_TO_INBOX": "Perkelti pokalbį į gautų laiškų aplanką",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Siųsti pranešimą naujame pokalbyje",
      "SEND_SMS_IN_NEW_CONVERSATION": "Siųsti SMS naujame pokalbyje",
      "STOP_PROCESSING_RULES": "Nutraukti taisyklių vykdymą"
    },
    "ATTRIBUTES": {
      "AI_FILTER": "AI filtras",
      "MESSAGE_TYPE": "Pranešimo tipas",
      "MESSAGE_CONTAINS": "Pranešimo turinys",
      "EMAIL": "Kontakto el. paštas",
      "INBOX": "Gautų laiškų aplankas",
      "CHANNEL_TYPE": "Gautų laiškų aplanko tipas",
      "CONVERSATION_LANGUAGE": "Pokalbio kalba",
      "PHONE_NUMBER": "Telefono numeris",
      "STATUS": "Būsena",
      "BROWSER_LANGUAGE": "Naršyklės kalba",
      "MAIL_SUBJECT": "El. laiško tema",
      "COUNTRY_NAME": "Šalis",
      "MARKETPLACE_COUNTRY": "Prekyvietės šalis",
      "REFERER_LINK": "Nukreipimo nuoroda",
      "ASSIGNEE_NAME": "Priskirtas agentas",
      "TEAM_NAME": "Komanda",
      "PRIORITY": "Prioritetas",
      "CALL_DIRECTION": "Skambučio kryptis",
      "MISSED_CALL": "Praleistas skambutis",
      "MISSED_CALL_COUNT": "Praleistų skambučių skaičius",
      "MESSAGE_SOURCE_TYPE": "Pranešimo šaltinio tipas",
      "INCOMING_MESSAGE_COUNT": "Gaunamų pranešimų skaičius",
      "OUTGOING_MESSAGE_COUNT": "Siunčiamų pranešimų skaičius",
      "LABEL": "Etiketė",
      "EMAIL_RECIPIENTS": "El. laiško gavėjas",
      "EMAIL_AUTO_REPLY": "El. laiškas yra automatinis atsakymas",
      "ATTACHMENT_EXTENSION": "Priedo plėtinys",
      "EXTENSION": "Skambučio vidinis numeris",
      "WORKING_HOURS": "Darbo valandomis",
      "AGENT_REPLIED": "Agentas atsakė nuo būsenos pakeitimo"
    },
    "WAIT": {
      "RUN_LABEL": "Vykdyti veiksmus",
      "INSTANT": "Įvykio metu",
      "DELAYED": "Su atidėjimu",
      "TRIGGER_LABEL": "Laukti, kol",
      "TRIGGERS": {
        "CONVERSATION_STATUS": "Pokalbis lieka tam tikros būsenos",
        "CUSTOMER_UNRESPONSIVE": "Klientas neatsako agentui",
        "AGENT_UNRESPONSIVE": "Klientas negauna agento atsakymo"
      },
      "STATUS_LABEL": "Būsena",
      "STATUSES": {
        "OPEN": "Atidarytas",
        "PENDING": "Laukiantis",
        "SNOOZED": "Atidėtas",
        "RESOLVED": "Išspręstas"
      },
      "DELAY_LABEL": "Laukimo trukmė",
      "DELAY_ERROR": "Įveskite laukimo trukmę nuo 1 minutės iki 30 dienų",
      "DURATION": {
        "MINUTES": "{count} min.",
        "HOURS": "{count} val.",
        "DAYS": "{count} d."
      },
      "EXPLANATION": {
        "CONVERSATION_STATUS": "Veiksmai vykdomi, kai pokalbis yra būsenos {status} {duration}. Ankstesnis būsenos pakeitimas juos atšaukia. Etiketės, darbo valandos ir agentų atsakymai tikrinami pasibaigus laukimui.",
        "CUSTOMER_UNRESPONSIVE": "Veiksmai vykdomi, kai klientas neatsako {duration} po agento žinutės. Kliento atsakymas juos atšaukia; nauja agento žinutė pradeda laukimą iš naujo.",
        "AGENT_UNRESPONSIVE": "Veiksmai vykdomi, kai klientas laukia {duration} be agento atsakymo. Agento atsakymas juos atšaukia."
      }
    }
  }
}
